import { Input, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";

const { Text } = Typography;

const dealers = [
  { key: "1", name: "Prime Motors", city: "Nairobi", tier: "Gold", listings: 138, manager: "A. Mwangi", status: "Review" },
  { key: "2", name: "Karibu Autos", city: "Mombasa", tier: "New", listings: 24, manager: "J. Ouma", status: "Pending" },
  { key: "3", name: "MileOne Imports", city: "Kisumu", tier: "Silver", listings: 57, manager: "S. Barasa", status: "Healthy" },
];

export default function WheelsDealersScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Wheels"
        title="Dealer Network"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All statuses" },
                { value: "healthy", label: "Healthy" },
                { value: "review", label: "Review" },
                { value: "pending", label: "Pending" },
              ]}
              style={{ width: 150 }}
            />
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All tiers" },
                { value: "gold", label: "Gold" },
                { value: "silver", label: "Silver" },
                { value: "new", label: "New" },
              ]}
              style={{ width: 130 }}
            />
            <Input.Search placeholder="Search dealer or manager" style={{ width: 240 }} />
          </div>
        }
      >
        <Text type="secondary">
          Dealer onboarding, partner health, and compliance belong to the Wheels vertical.
        </Text>
      </GlassPanel>

      <GlassPanel title="Dealer Accounts">
        <Table
          rowKey="key"
          size="small"
          pagination={{ pageSize: 10, showSizeChanger: false }}
          dataSource={dealers}
          columns={[
            { title: "Dealer", dataIndex: "name" },
            { title: "City", dataIndex: "city" },
            { title: "Tier", dataIndex: "tier" },
            { title: "Listings", dataIndex: "listings" },
            { title: "Manager", dataIndex: "manager" },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => <Tag color={value === "Healthy" ? "success" : value === "Pending" ? "processing" : "warning"}>{value}</Tag>,
            },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
